const local = {
  instruction: "How does DNA affect Puppy?",
  races: ["Shar Pei", "Sheepdog", "Coonhound", "Afghan Hound", "Great Dane"],
  scale: ["LITTLE", "MEDIUM", "LARGE"],
  serialNumber: "Serial Number",
  specialid: "Special ID",
  race: "Breed",
  economic: "ECONOMIC",
  military: "MILITARY",
  cards: [
    "Puppy Size",
    "Puppy Style",
    "Puppy Color",
    "Logo Style",
    "Logo Color",
    "Logo Position",
    "Breed",
    "Special ID",
  ],
};

export { local };
